import { createPlugin } from '@front/utils/alpine';

function resize (iframe: HTMLIFrameElement) {
    iframe.height = iframe.contentWindow?.document.body.scrollHeight.toString() || '0';
}

export default createPlugin((vm) => {

    vm.directive('fit-iframe', (el, { modifiers, expression }, { evaluate }) => {
        const iframe = el as HTMLIFrameElement;
        iframe.addEventListener('load', () => {
            resize(iframe);
            window.addEventListener('resize', () => resize(iframe));
        });
    });

});
